"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fileToBase64 = void 0;
/**
 * Mapuje plik na base64
 *
 * @export
 * @param {File} file
 * @returns {Promise<string>}
 */
function fileToBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.readAsDataURL(file);
        reader.onerror = (error) => reject(error);
    });
}
exports.fileToBase64 = fileToBase64;
//# sourceMappingURL=fileToBase64.js.map